import { render } from "./CarouselBranding.vue?vue&type=template&id=78053b79"
import script from "./CarouselBranding.vue?vue&type=script&lang=js"
export * from "./CarouselBranding.vue?vue&type=script&lang=js"

import "./CarouselBranding.vue?vue&type=style&index=0&id=78053b79&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__